import React, { useEffect } from "react";
import { useUser } from "../contexts/UserContext.tsx";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../constants/route.ts";

const RouteResolver: React.FC = () => {
  const { roles } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (roles?.includes("ROLE_MARKETING_QUERY_BUILD")) {
      navigate(RouteConstants.MARKETING_CAMPAIGN.CREATE, { replace: true });
    } else if (roles?.includes("ROLE_EMAIL_LIST_LOAD")) {
      navigate(RouteConstants.EMAIL_LISTS.UPLOAD, { replace: true });
    }
  }, [roles]);

  return null;
};

export default RouteResolver;
